import { LangSwitcher } from '@/lib/i18n';
import { NAVY, GOLD } from '@/lib/colors';
import { crossAppHref } from '@/lib/nav';

export type NavActive = 'home' | 'product';

export type NavLabels = {
  home: string;
  product: string;
  signin: string;
  signup: string;
};

export function Nav({ active, labels }: { active: NavActive; labels: NavLabels }) {
  const item = (key: NavActive, href: string, lbl: string) => (
    <a
      href={href}
      aria-current={active === key ? 'page' : undefined}
      style={{
        background: active === key ? 'rgba(255,255,255,0.10)' : 'transparent',
        color: 'rgba(255,255,255,0.92)',
        fontFamily: 'Sarabun',
        fontSize: 14,
        fontWeight: active === key ? 600 : 400,
        padding: '8px 16px',
        borderRadius: 6,
        textDecoration: 'none',
      }}>
      {lbl}
    </a>
  );
  return (
    <nav
      role="navigation"
      aria-label="primary"
      style={{
        background: NAVY,
        padding: '0 48px',
        height: 72,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
      <a href={crossAppHref('/')} style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>
        <img
          src="/assets/logo-nav.png"
          alt="Invosly"
          style={{ height: 48, borderRadius: 8, background: '#fff', padding: '4px 10px' }}
        />
      </a>
      <div style={{ display: 'flex', gap: 4 }}>
        {item('home', crossAppHref('/'), labels.home)}
        {item('product', crossAppHref('/product'), labels.product)}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <a
          href={crossAppHref('/login')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            textDecoration: 'none',
            background: 'transparent',
            border: '1.5px solid rgba(255,255,255,0.4)',
            color: '#fff',
            fontFamily: 'Sarabun',
            fontSize: 14,
            padding: '7px 18px',
            borderRadius: 6,
          }}>
          {labels.signin}
        </a>
        <a
          href={crossAppHref('/signup')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            textDecoration: 'none',
            background: GOLD,
            color: '#fff',
            fontFamily: 'Sarabun',
            fontSize: 14,
            fontWeight: 600,
            padding: '8px 18px',
            borderRadius: 6,
          }}>
          {labels.signup}
        </a>
        <LangSwitcher />
      </div>
    </nav>
  );
}
